import { render } from "./EditInvoice.vue?vue&type=template&id=5fb9e050&ts=true"
import script from "./EditInvoice.vue?vue&type=script&lang=ts"
export * from "./EditInvoice.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__